import { render, staticRenderFns } from "./toggle-visualtype.vue?vue&type=template&id=5a8fec19"
import script from "./toggle-visualtype.vue?vue&type=script&lang=js"
export * from "./toggle-visualtype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports